<template>
  <div class="h-100-trim-header">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "layouts-passthrough"
};
</script>
